/*
 * @description: 
 * @author: Jason Wong
 * @since: 2021-07-30 09:35:11
 */
/* 数据操作类方法集合
 * @description: 
 * @author: Jason Wong 
 * @since: 2020-05-26 16:21:35 
 */

import DayJS from "dayjs";

/**
 * 返回给定月份的天数
 * @param {Number} year
 * @param {Number} month
 */
function getMonthDaysCount(year, month) {
  let date = new Date(year, month + 1, 1);
  date.setDate(date.getDate() - 1);
  return date.getDate();
}

/**
 * 将给定的时间格式化为年月日的形式
 * @param {Date} time
 */
function toDate(time) {
  if (!time) return "-";
  return DayJS(time).format("YYYY-MM-DD");
}

/**
 * toDate方法的变体，用于直接给element ui的:formater使用
 * @param {Object} row
 * @param {Number} column
 * @param {Number} cellValue
 * @param {Number} index
 */
function elementTableCellToDateFormatter(row, column, cellValue, index) {
  if (!cellValue) return "-";
  return DayJS(cellValue).format("YYYY-MM-DD");
}

/**
 * 将时间格式化为YYYY-MM-DD HH:mm的形式
 * @param {Date} time
 */
function Y_M_D_H_m(time) {
  return time ? DayJS(time).format("YYYY-MM-DD HH:mm") : "-";
}

/**
 * 将时间格式化为YYYY-MM-DD HH:mm:ss的形式
 * @param {Date} time
 */
 function Y_M_D_H_m_s(time) {
  return time ? DayJS(time).format("YYYY-MM-DD HH:mm:ss") : "-";
}

function M_D_H_m_s(time) {
  return time ? DayJS(time).format("MM-DD HH:mm") : "-";
}

function H_m(time) {
  return time ? DayJS(time).format("HH:mm") : "-";
}

/**
 * 将时间格式化为YYYY-MM-DD HH的形式
 * @param {Date} time
 */
function Y_M_D_H(time) {
  return time ? DayJS(time).format("YYYY-MM-DD HH:00") : "-";
}

function delay(ms) {
  return new Promise((res) => {
    setTimeout(() => {
      res();
    }, ms);
  });
}

/**
 * 
 * @param {()=>bool} handler 
 * @param {Number} interval 
 */
function waitDone(handler,interval){
  let timerId;

  function executeHandler(){
    timerId = setTimeout(async () => {
      const shouldExit = await handler();
      !shouldExit && executeHandler();
    }, interval);
  }
  
  executeHandler();
}

/**
 * 两个时间的差值，格式: HH:mm:ss
 * @param {*} end
 * @param {*} start
 */
function getElapsedTime(end, start) {
  end = DayJS(end);
  start = DayJS(start);
  if (!end.isValid() || !start.isValid()) {
    return "-";
  }
  const sec_num = parseInt(end.diff(start, "second"), 10);
  let hours = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - hours * 3600) / 60);
  let seconds = sec_num - hours * 3600 - minutes * 60;
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + (seconds === 0 ? 1 : seconds);
  }
  return hours + ":" + minutes + ":" + seconds;
}

export {
  getMonthDaysCount,
  toDate,
  elementTableCellToDateFormatter,
  Y_M_D_H_m,
  Y_M_D_H_m_s,
  H_m,
  delay,
  getElapsedTime,
  waitDone,
  M_D_H_m_s,
  Y_M_D_H
};
